<template>
  <div class="index">
    <div class="commentsbox">
      <p class="title">我来评价，共有&nbsp;<span>{{commentNum}}</span>&nbsp;人评论</p>
      <div class="comments">
        <el-radio-group v-model="score">
          <el-radio :label="5">好评</el-radio>
          <el-radio :label="3">中评</el-radio>
          <el-radio :label="1">差评</el-radio>
        </el-radio-group>
        <div class="contbox">
          <el-input type="textarea" :rows="5" placeholder="请输入内容" v-model="content"></el-input>
        </div>
        <el-button type="danger" @click="sendComments()">发送</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['targetId','type','commentNum'],
  data() {
    return {
      score:5,
      content:'',
    }
  },
  methods:{
    async sendComments() {//发送评价
      await this.$api.get_user_login_info().then(async (res)=> {
        if (res.data.status == 0) {//用户已登陆
          if (this.score == '') {
            this.$message.info('请选择评论等级！')
          } else {
            if (this.content == '') {
              this.$message.info('请输入评价内容！')
            } else {//提交评价
              let newData = {}
              newData.targetId = this.targetId
              newData.userId = JSON.parse(window.localStorage.getItem('loginData')).id
              newData.userName = JSON.parse(window.localStorage.getItem('loginData')).u_nickName
              newData.score = this.score
              newData.content = this.content
              newData.type = this.type
              console.log(newData)

              this.$api.createComment(newData).then(res => {
                if (res.data.status == 0) {
                  this.$message.success('评论成功！')
                  this.content = ''
                  this.$emit('refresh')
                } else { this._status(res.data) }
              })
            }
          }
        } else { this._status(res.data) }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
/* @import url(); 引入css类 */
.commentsbox{
  border: 1px solid #eee;
  margin-top: 40px;
  .title{
    color: #666;
    padding-left: 20px;
    height: 50px;
    border-bottom: 1px solid #eeeeee;
    line-height: 50px;
    background-color: #f8f8f8;
    span{
      color: #ff6766;
    }
  }
  .comments{
    padding: 25px;
    .contbox{
      margin-top: 20px;
    }
    button{
      position: relative;
      left: 85%;
      margin-top: 15px;
      width: 120px;
      height: 40px;
    }
  }
}
</style>